// @flow
import DeviceIcon from '~/core/icons/device-icon';
import { iconContainerSize } from '../style-variables';
import styled from 'styled-components';

export const Container = styled.div`
    align-items: center;
    display: flex;
    justify-content: flex-start;
    padding: 0.5em 1em;
`;

export const IconWrapper = styled.div`width: ${2.5 * iconContainerSize}em;`;

export const StyledDeviceIcon = styled(DeviceIcon)`
    align-items: center;
    background-color: ${p => (p.active ? p.theme.mainBrandColor : p.theme.secondaryColor)};
    border-radius: 50%;
    color: ${p => p.theme.white};
    display: flex;
    font-size: 2.5em;
    height: ${iconContainerSize}em;
    justify-content: center;
    transition: background-color 0.3s ease-in;
    width: ${iconContainerSize}em;
`;

export const Summary = styled.div`
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
    margin-left: 1em;
`;

export const Device = styled.span`
    font-size: 1.5em;
    margin-left: 0.25em;
`;

export const Action = styled.span`
    margin: 0.1em 0 0 0.45em;
    color: ${p => p.theme.mainBrandColor};
`;



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/device-selector/style.js